export enum TriageRelationshipType {
  EMPTY = '',
  SPOUSE = 'SPOUSE',
  BENEFICIARY = 'BENEFICIARY',
  PERSTIRPES = 'PERSTIRPES',
  EXECUTOR = 'EXECUTOR',
  TRUSTEE = 'TRUSTEE',
}

export enum TriageRelationshipTypeNames {
  EMPTY = ``,
  SPOUSE = `I'm the spouse`,
  BENEFICIARY = `I'm the beneficiary (non-spouse)`,
  PERSTIRPES = `I'm listed as a descendent/grandchild per stirpes`,
  EXECUTOR = `I'm the executor`,
  TRUSTEE = `I'm a trustee`,
}
